import http from './http';

export function getUser() {
	return http.get('/user').then(resp => resp.data.data);
}

export function updateProfile(payload) {
	return http.put('/user/profile', payload).then(resp => resp.data);
}

export function updateProfilePassword(payload) {
	return http.put('/user/password', payload).then(resp => resp.data);
}
